/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  return 5;
}

export default [
  'bm',
  [
    ['AM', 'PM'],
    ,
  ],
  ,
  [
    ['K', 'N', 'T', 'A', 'A', 'J', 'S'], ['kar', 'ntɛ', 'tar', 'ara', 'ala', 'jum', 'sib'],
    ['kari', 'ntɛnɛ', 'tarata', 'araba', 'alamisa', 'juma', 'sibiri'],
    ['kar', 'ntɛ', 'tar', 'ara', 'ala', 'jum', 'sib']
  ],
  ,
  [
    ['Z', 'F', 'M', 'A', 'M', 'Z', 'Z', 'U', 'S', 'Ɔ', 'N', 'D'],
    ['zan', 'feb', 'mar', 'awi', 'mɛ', 'zuw', 'zul', 'uti', 'sɛt', 'ɔku', 'now', 'des'],
    [
      'zanwuye', 'feburuye', 'marisi', 'awirili', 'mɛ', 'zuwɛn', 'zuluye', 'uti', 'sɛtanburu',
      'ɔkutɔburu', 'nowanburu', 'desanburu'
    ]
  ],
  , [['J.-C. ɲɛ', 'ni J.-C.'], , ['jezu krisiti ɲɛ', 'jezu krisiti minkɛ']], 1, [6, 0],
  ['d/M/y', 'd MMM, y', 'd MMMM y', 'EEEE d MMMM y'],
  ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
  [
    '{1} {0}',
    ,
    ,
  ],
  ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
  ['#,##0.###', '#,##0%', '¤#,##0.00', '#E0'], 'CFA', 'sefa Fraŋ (BCEAO)', plural
];
